import React from 'react';

const Setting = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 14.1957C12.5188 14.1957 13.75 12.9509 13.75 11.4153C13.75 9.87963 12.5188 8.63477 11 8.63477C9.48122 8.63477 8.25 9.87963 8.25 11.4153C8.25 12.9509 9.48122 14.1957 11 14.1957Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.83203 12.2299V10.5987C1.83203 9.63476 2.6112 8.83769 3.5737 8.83769C5.23286 8.83769 5.9112 7.65134 5.07703 6.19622C4.60036 5.36207 4.88453 4.27768 5.7187 3.79573L7.30453 2.87817C8.0287 2.44256 8.9637 2.70207 9.39453 3.43427L9.49536 3.61036C10.3204 5.06549 11.677 5.06549 12.5112 3.61036L12.612 3.43427C13.0429 2.70207 13.9779 2.44256 14.702 2.87817L16.2879 3.79573C17.122 4.27768 17.4062 5.36207 16.9295 6.19622C16.0954 7.65134 16.7737 8.83769 18.4329 8.83769C19.3862 8.83769 20.1745 9.62549 20.1745 10.5987V12.2299C20.1745 13.1938 19.3954 13.9909 18.4329 13.9909C16.7737 13.9909 16.0954 15.1772 16.9295 16.6323C17.4062 17.4757 17.122 18.5509 16.2879 19.0328L14.702 19.9504C13.9779 20.386 13.0429 20.1265 12.612 19.3943L12.5112 19.2182C11.6862 17.7631 10.3295 17.7631 9.49536 19.2182L9.39453 19.3943C8.9637 20.1265 8.0287 20.386 7.30453 19.9504L5.7187 19.0328C4.88453 18.5509 4.60036 17.4665 5.07703 16.6323C5.9112 15.1772 5.23286 13.9909 3.5737 13.9909C2.6112 13.9909 1.83203 13.1938 1.83203 12.2299Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Setting;
